import { OrderSpecialRequest } from '../models/order-special-request';
import { dateMapper } from './date.mapper';

/**
 * Map to eLearning detail.
 * @param {object} dto Dto.
 * @returns {OrderSpecialRequest}
 */
function fromDto(dto) {
  return new OrderSpecialRequest({
    id: dto.id,
    userId: dto.user_id,
    orderItemId: dto.order_item_id,
    registrationId: dto.registration_id,
    type: dto.type,
    newRegistrationId: dto.new_registration_id,
    createdAt: dateMapper.fromDto(dto.created_at),
    updatedAt: dateMapper.fromDto(dto.updated_at),
  });
}

export const orderSpecialRequest = {
  fromDto,
};
